import CustomButton from "@components/buttons/CustomButton";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { groupManagementApi } from "@services/apis/GroupManagement";
import {
  AddMemberToGroupRequest,
  AddMemberToGroupResponse,
} from "@services/models/Groups/AddMemberToGroup";
import React, { useState } from "react";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface AddCashierToGroupSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onCashierAdded?: () => void;
  selectedGroupId: string | null;
  selectedGroupName: string | null;
}

const AddCashierToGroupSlider: React.FC<AddCashierToGroupSliderProps> = ({
  isOpen,
  onClose,
  onCashierAdded,
  selectedGroupId,
  selectedGroupName,
}) => {
  const [cashierUserId, setCashierUserId] = useState<string>("");
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
  const { handleError, handleSuccess } = useSnackbarMessage();

  const checkValidInput = () => {
    const cashierIdNum = parseInt(cashierUserId.trim());
    return (
      cashierUserId.trim().length > 0 &&
      !isNaN(cashierIdNum) &&
      cashierIdNum > 0 &&
      selectedGroupId !== null
    );
  };

  const handleSubmit = async () => {
    if (!selectedGroupId) {
      handleError({ message: "Please select a group first" });
      return;
    }

    try {
      setIsButtonLoading(true);
      const addMemberRequest: AddMemberToGroupRequest = {
        groupId: parseInt(selectedGroupId),
        memberId: parseInt(cashierUserId.trim()),
        roleType: "cashier",
      };
      const response: AddMemberToGroupResponse =
        await groupManagementApi.addMemberToGroup(addMemberRequest);
      handleSuccess({
        message: response.msg || "Cashier added to group successfully",
      });
      setCashierUserId("");
      onCashierAdded?.();
      onClose();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.msg ||
        "Adding cashier to group failed. Please try again.";
      handleError({ message: errorMessage });
    } finally {
      setIsButtonLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={`Add Cashier to Group ${
        selectedGroupName ? `(${selectedGroupName})` : ""
      }`}
      onClose={onClose}
      onClickCross={onClose}
      showConfirm={false}
    >
      <div className="flex flex-col px-[16px] py-[16px] gap-4">
        <GlobalTextInputField
          placeholder="Enter cashier user ID"
          value={cashierUserId}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setCashierUserId(e.target.value)
          }
          type="number"
          allowDecimal={false}
          title="Enter the cashier user ID to add to the group."
        />
        <div className="my-4">
          <CustomButton
            text="ADD CASHIER"
            onClick={handleSubmit}
            isActive={checkValidInput()}
            isButtonLoading={isButtonLoading}
          />
        </div>
      </div>
    </SlidingPanel>
  );
};

export default AddCashierToGroupSlider;
